import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import _ from "lodash";

export const defaultLocation = {
  // zoom: 5,
  // center: {
  //     lat: 39.14588487254405,
  //     lng: -97.69366152343753
  // },
  // bounds: [
  //   26.670601317843065,
  //   49.748316105646495,
  //   -139.88116152343753,
  //   -55.50616152343753
  // ]
  zoom: 5,
  center: null,
  bounds: [ // Bounds for continental US
    23.924195828920954, // South
    51.01250390833167, // North
    -126.92197645479062, // West
    -64.82724989229064 // East
  ]
}

export const initialState = {
  ...defaultLocation,
  forceFetchAfterFitBounds: false,
  pins: [],
  filterEditorOpen: false,
  customShapesEditorOpen: false,
  customShape: null,
  shapes: [],
  shapesColoringType: "MedianIncome",
  shapesGeoType: null,
  propertyDetailsBoxIsOpen: false,
  propertyDetailsIsOpen: false,
  viewUnderwriteModalIsOpen: false,
  searchPin: null,
  mapType: 'default',
  isRedirectToExplore: false,
  colorMatrixObj: null,
  markerOptions: {
    enableRounding: true,
    autoBreakoutThreshold: 10000
  },
  gridIsCollapsed: true
}

const slice = createSlice({
  name: 'exploreMapSlice',
  initialState,
  reducers: {
    setExplorePins: (state, action) => {
      state.pins = action.payload;
    },
    setExploreLocation: {
      reducer: (state, action) => {
        const { location, forceFetchAfterFitBounds } = action.payload;
        return {
          ...state,
          zoom: location.hasOwnProperty('zoom') ? location.zoom : state.zoom,
          center: location.hasOwnProperty('center') ? location.center : state.center,
          bounds: location.hasOwnProperty('bounds') ? location.bounds : state.bounds,
          forceFetchAfterFitBounds
        }
      },
      prepare: (location, shouldFetch = true, forceFetchAfterFitBounds = false) => ({ payload: { location, shouldFetch, forceFetchAfterFitBounds } })
    },
    toggleExploreFilterEditor: (state, action) => {
      state.filterEditorOpen = action.payload;
    },
    toggleExploreCustomShapesEditor: (state, action) => {
      state.customShapesEditorOpen = action.payload;
    },
    setExploreCustomShape: (state, action) => {
      state.customShape = action.payload;
    },
    setExploreShapes: (state, action) => {
      state.shapes = action.payload;
    },
    setExploreShapesColoringType: (state, action) => {
      state.shapesColoringType = action.payload;
    },
    setExploreShapesGeoType: (state, action) => {
      state.shapesGeoType = action.payload;
    },
    setExplorePropertyDetailsBoxIsOpen: (state, action) => {
      state.propertyDetailsBoxIsOpen = action.payload;
    },
    setExplorePropertyDetailsIsOpen: (state, action) => {
      state.propertyDetailsIsOpen = action.payload;
    },
    setExploreViewUnderwriteModalIsOpen: (state, action) => {
      state.viewUnderwriteModalIsOpen = action.payload
    },
    setExploreSearchPin: (state, action) => {
      state.searchPin = action.payload;
    },
    setExploreMapType: (state, action) => {
      state.mapType = action.payload;
    },
    setIsRedirectToExplore: (state, action) => {
      state.isRedirectToExplore = action.payload;
    },
    updateExploreMarkerOptions: (state, action) => {
      state.markerOptions = {
        ...state.markerOptions,
        ...action.payload
      };
    },
    setExploreGridIsCollapsed: (state, action) => {
      state.gridIsCollapsed = action.payload;
    },
    getPropertyDetailsDataForProspect: () => { }
  }
});

export const exploreMapActions = slice.actions;
export default slice.reducer;

// Memoized selectors
export const exploreMapSelectors = {
  exploreMapSelector: createSelector(
    state => state.exploreMap,
    exploreMap => exploreMap
  ),
  exploreColorMatrixObjSelector: createSelector(
    [state => state.exploreMap.pins, state => state.exploreMap.pinDisplayType],
    (pins, pinDisplayType) => {
      if (!pins) return {};
      const colorByField = pinDisplayType?.dataField ?? 'propertiesCount';
      return {
        maxObj: _.maxBy(pins, colorByField),
        minObj: _.minBy(pins, colorByField),
        colorByField,
        noDataColor: '#afafaf'
      }
    }
  )
}
